// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { FormValidator } from '../../../utils/form';
import classNames from 'classnames/bind';
import Select from '../../Select/Select';

import formStyle from '../../../assets/styles/form.scss';
import inputStyle from '../../../assets/styles/input.scss';

import type { Address } from '../../../entities';
import type { Option } from '../../Select/Select';

type Props = {
  +isPosting?: boolean;
  +addresses?: Address[];
  +handleChange: (e: SyntheticInputEvent<HTMLInputElement>) => void;
  +handleChangeAddressOption?: (option: Option) => void;
  +handleFocus: (e: Event) => void;
  +country: string;
  +firstName: {
    value: string;
    errors?: string[];
  };
  +idNumber: {
    value: string;
    errors?: string[];
  };
  +lastName: {
    value: string;
    errors?: string[];
  };
  +addressOption: {
    value: string;
    errors?: string[];
  };
};

const messages = defineMessages({
  myAddresses: {
    label: {
      id: 'address.myAddresses.label',
    },
    placeholder: {
      id: 'address.myAddresses.placeholder',
    },
  },
  firstName: {
    label: {
      id: 'address.firstName.label',
    },
    placeholder: {
      id: 'address.firstName.placeholder',
    },
  },
  idNumber: {
    label: {
      id: 'address.idNumber.label',
    },
    placeholder: {
      id: 'address.idNumber.placeholder',
    },
  },
  lastName: {
    label: {
      id: 'address.lastName.label',
    },
    placeholder: {
      id: 'address.lastName.placeholder',
    },
  },
});

export default class Top extends Component<Props> {

  render() {
    const {
      isPosting, addresses, handleChange, handleChangeAddressOption, handleFocus, country, firstName, idNumber, lastName,
      addressOption
    } = this.props;
    const firstNameError = firstName.errors && FormValidator.buildErrorLabel(firstName.errors, {
      required: 'address.firstName.error.required',
    });
    const idNumberError = idNumber.errors && FormValidator.buildErrorLabel(idNumber.errors, {
      required: 'address.idNumber.error.required',
    });
    const lastNameError = lastName.errors && FormValidator.buildErrorLabel(lastName.errors, {
      required: 'address.lastName.error.required',
    });
    const countryIsUS = country === 'US';
    const addressesOptions = addresses ? addresses.map((address: Address) => (
      {
        value: address.id,
        label: address.name,
      }
    )) : [];
    const myAddressesOptions = [{
      value: 'new-address',
      labelId: 'address.myAddresses.option.newAddress',
    }, ...addressesOptions];
    const changeAddressOption = handleChangeAddressOption || (_ => undefined);
    return (
      <form className={formStyle.formWrap}>
        <section className={classNames(formStyle.row, formStyle.inputRow)}>
          <article className={classNames(formStyle.col)}>
            <FormattedMessage id={messages.myAddresses.label.id}>{
              txt => (<label className={formStyle.label}>{txt}:</label>)
            }</FormattedMessage>
            <FormattedMessage id={messages.myAddresses.placeholder.id}>{
              txt => <Select options={myAddressesOptions}
                             className={classNames({
                               // 'light-blue': admin1.value,
                             })}
                             value={addressOption.value}
                             placeholder={txt}
                             handleChange={changeAddressOption}/>
            }</FormattedMessage>
          </article>
        </section>
        <section
          className={classNames(formStyle.row, formStyle.inputRow, formStyle.dualWrap, formStyle.responsiveMedium)}>
          <article className={classNames(formStyle.col)}>
            <FormattedMessage id={messages.firstName.label.id}>{
              txt => (<label className={formStyle.label}>{txt}:</label>)
            }</FormattedMessage>
            <input disabled={isPosting}
                   className={classNames(inputStyle.input, { [inputStyle.red]: firstName.errors && firstName.errors.length },
                     { [inputStyle.lightBlue]: !!firstName.value })}
                   value={firstName.value}
                   onChange={handleChange}
                   onFocus={handleFocus}
                   name="firstName"
                   placeholder={this.context.intl.formatMessage(messages.firstName.placeholder)}/>
            {firstNameError}
          </article>
          <article className={classNames(formStyle.col)}>
            <FormattedMessage id={messages.lastName.label.id}>{
              txt => (<label className={formStyle.label}>{txt}:</label>)
            }</FormattedMessage>
            <input disabled={isPosting}
                   className={classNames(inputStyle.input, { [inputStyle.red]: lastName.errors && lastName.errors.length },
                     { [inputStyle.lightBlue]: !!lastName.value })}
                   value={lastName.value}
                   onChange={handleChange}
                   onFocus={handleFocus}
                   name="lastName"
                   placeholder={this.context.intl.formatMessage(messages.lastName.placeholder)}/>
            {lastNameError}
          </article>
        </section>
        {!countryIsUS &&
        <section
          className={classNames(formStyle.row, formStyle.inputRow, formStyle.dualWrap, formStyle.responsiveMedium)}>
          <article className={classNames(formStyle.col)}>
            <FormattedMessage id={messages.idNumber.label.id}>{
              txt => (<label className={formStyle.label}>{txt}:</label>)
            }</FormattedMessage>
            <input disabled={isPosting}
                   className={classNames(inputStyle.input, { [inputStyle.red]: idNumber.errors && idNumber.errors.length },
                     { [inputStyle.lightBlue]: !!idNumber.value })}
                   value={idNumber.value}
                   onChange={handleChange}
                   onFocus={handleFocus}
                   name="idNumber"
                   placeholder={this.context.intl.formatMessage(messages.idNumber.placeholder)}
                   type="tel"/>
            {idNumberError}
          </article>
        </section>}
      </form>
    )
  }
}

Top.propTypes = {
  isPosting: PropTypes.bool,
  addresses: PropTypes.array,
  handleChange: PropTypes.func.isRequired,
  handleChangeAddressOption: PropTypes.func,
  handleFocus: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
  firstName: PropTypes.object.isRequired,
  idNumber: PropTypes.object.isRequired,
  lastName: PropTypes.object.isRequired,
  addressOption: PropTypes.object.isRequired,
};

Top.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/elements/AddressForm/MyAddressType/Top.jsx